import { useTranslate } from '@growtherapy/i18n';

import { EndSessionButton } from '../../components';

export function LeaveSessionButton({
  onClick,
  ...props
}: {
  onClick: () => void;
} & Omit<React.ComponentProps<typeof EndSessionButton>, 'aria-label'>) {
  const t = useTranslate();
  return (
    <EndSessionButton onClick={onClick} {...props} aria-label={t('telehealth-core:controls.leaveSession')}>
      {t('telehealth-core:controls.leaveSession')}
    </EndSessionButton>
  );
}
